const officers = [
  {
    title: "President",
    names: ["Rich Kindle"]
  },
  {
    title: "Vice President",
    names: ["Sara Corman"]
  },
  {
    title: "Secretary",
    names: ["Kari Taylor"]
  },
  {
    title: "Treasurer",
    names: ["Lizzie Huff"]
  },
  {
    title: "Historian & Picture Boards",
    names: ["Nancy Love"]
  }
];

const roles = [
  {
    title: "Prep Team",
    names: ["Jackie Callahan", "Bill Dudley", "Susie Dudley", "Chris Wright", "Sarah Wright"]
  },
  {
    title: "Group Picture Photographer",
    names: ["Paul Pettit"]
  },
  {
    title: "Historical Photos Activity",
    names: ["Peggy Boyer"]
  },
  {
    title: "Auction",
    names: ["Gene Corman", "Anna Corman"]
  },
  {
    title: "Kids' Activities",
    names: ["Erin Wasser"]
  },
  {
    title: "Catered Meals Coordinators",
    names: ["Sara Corman", "Connie Corman"]
  },
  {
    title: "Photo Contest",
    names: ["Beth Melvin"]
  },
  {
    title: "Photographer",
    names: ["Paul Pettit"]
  },
  {
    title: "Scavanger Hunt",
    names: ["Liz Huff"]
  },
  {
    title: "Talent Show",
    names: ["Rich Kindle"]
  },
  {
    title: "Prizes for Kids' Activities",
    names: ["Jill Dudley"]
  },
  {
    title: "Tech Support",
    names: ["Rich Kindle"]
  },
  {
    title: "T-shirt Tie Dye",
    names: ["Megan Pinero"]
  },
  {
    title: "Cookie Contest Coordinator",
    names: ["Jackie Callahan"]
  },
  {
    title: "Saturday Lunch",
    names: ["Connie Corman & family handling setup arrangements"]
  },
  {
    title: "Sunday Morning Worship Music",
    names: ["Monty Kindle", "Rich Kindle"]
  },
  {
    title: "Sunday Morning Devotional",
    names: ["Don Love"]
  },
  {
    title: "Cleanup Helpers (end of reunion)",
    names: ["Anyone who can help!"]
  },
  {
    title: "Possible Hunter Trip",
    names: ["Dan Corman", "Nancy Love"]
  }
];

export { officers, roles };
